import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../components/commentBox";
import PageHeader from "../../../components/pageHeader";
import TaskCheckedList from "../../../components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

function PaymentRecieved({ itemId, listId, alreadyCheckedItems }) {
  const isItemChecked = alreadyCheckedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="Payment Received" />
          </Col>
          <Col span={24}>
            <h1 className="red-info-heading">
              If we have filed eviction check the cancel eviction task if not
              filed then follow steps below.
            </h1>
          </Col>
          <Col span={24}>
            <h3>
              If payment was received go into appfolio and uncheck evict on the
              tenant page and check accept online payments again.
            </h3>
          </Col>
          <Col span={24}>
            <h3 className="yellow-info-text">Send this message to the owner</h3>
          </Col>
          <Col span={24}>
            <p>
              Your tenant has paid at least 75% of the balance owed. we have
              dismissed the eviction and will update you as things change.
            </p>
          </Col>
          <Col span={24}>
            <h3 className="green-info-text">
              Send this message to the tenant
            </h3>
          </Col>
          <Col span={24}>
            <p>
              Thank you for getting caught up with your rent your payment has
              been accepted. Due to the fact that this was accepted after filing
              for eviction there will be court and attorney fees added to your
              ledger in the coming weeks.
            </p>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary" onClick={handleComplete} disabled={isDisabled}>Complete</Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default PaymentRecieved;
